import React from "react"
import { ProviderFinderParam, useBooleanSearchParam } from "../../utils/providerFinderSearchUrl"
import { FormattedMessage, useIntl } from "react-intl"
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  TrophyIcon,
  Typography
} from "@carrotfertility/carotene-core"
import { useProviderTypeSearched } from "#/pages/provider-finder/components/results/useProviderTypeSearched"
import useGetMemberCountry from "#/components/company/hooks/useGetMemberCountry"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { useJourney } from "#/components/carrot-plans/hooks/useJourney"

export function CarrotCenterOfExcellenceFilter(): JSX.Element {
  const [carrotCenterOfExcellenceSearchParam, setCarrotCenterOfExcellenceSearchParam] = useBooleanSearchParam(
    ProviderFinderParam.CarrotCenterOfExcellence
  )
  const intl = useIntl()
  const { isFertilityClinicsSearched } = useProviderTypeSearched()
  const memberCountry = useGetMemberCountry()
  const countryCode = memberCountry?.data?.countryCode
  const { mutate: addMemberAction } = useMemberActionTracking()
  const { resolvedJourney } = useJourney()

  if (!(isFertilityClinicsSearched && countryCode === "US")) {
    return null
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      padding={(theme) => theme.spacing(theme.tokens.spacing.sm)}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.tokens.borderRadius.sm
      })}
    >
      <Box display="flex" flexDirection="column" gap={(theme) => theme.spacing(theme.tokens.spacing.md)}>
        <FormControl>
          <FormControlLabel
            label={
              <Box
                component="span"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: (theme) => theme.spacing(theme.tokens.spacing.xxs),
                  minBlockSize: (theme) => theme.spacing(theme.tokens.spacing.lg)
                }}
              >
                <TrophyIcon fontSize="small" color="primary" />
                <Typography fontWeight="bold" textTransform="uppercase" fontSize="0.75rem">
                  <FormattedMessage defaultMessage="Top success Rates" />
                </Typography>
              </Box>
            }
            aria-label={intl.formatMessage({ defaultMessage: "Select Carrot Center of Excellence type" })}
            control={
              <Checkbox
                name="carrotCenterOfExcellence"
                checked={carrotCenterOfExcellenceSearchParam}
                onChange={(event) => {
                  const isChecked = event.target.checked
                  setCarrotCenterOfExcellenceSearchParam(isChecked)
                  addMemberAction({
                    memberActionTaken: MemberActions.PROVIDER_FINDER_CCOE_FILTER_TOGGLED,
                    metaData: {
                      filterEnabled: isChecked,
                      memberJourney: resolvedJourney
                    }
                  })
                }}
              />
            }
          />
          <FormHelperText sx={{ paddingInlineStart: (theme) => theme.spacing(theme.tokens.spacing.xxl) }}>
            <FormattedMessage defaultMessage="Carrot Centers of Excellence are high-quality clinics with best-in-class outcomes." />
          </FormHelperText>
        </FormControl>
      </Box>
    </Box>
  )
}
